import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import DelegationService from './delegation.service'

//TODO: Test
export const useDelegation = () => {
  const service = new DelegationService()
  const baseCrud = useCrud(API_RESOURCE.DELEGATION, service)

  const queryClient = useQueryClient()

  const useUploadDelegations = () => {
    return useMutation({
      mutationFn: service.uploadDelegation,
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.DELEGATION)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllDelegations: baseCrud.useFetchAll,
    useFetchDelegation: baseCrud.useFetchOne,
    useCreateDelegation: baseCrud.useCreate,
    useUpdateDelegation: baseCrud.useUpdate,
    useRemoveDelegation: baseCrud.useRemove,

    //Extra
    useUploadDelegations,
  }
}
